import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { resolveBrandDisplayName } from "../../utils/brandingUtils";

export default function DummyHeaderCard({
  companyName = "Company",
  subtitle = "Business Chat",
  bgColor = "#303030",
}) {
  const [time, setTime] = useState("");
  const companyConfig = useSelector((state) => state?.whitelabel?.companyData?.data);
  const brandName = resolveBrandDisplayName(companyConfig, companyName);
  const logoUrl = companyConfig?.logoUrl;

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      setTime(`${hours}:${minutes}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="w-full px-3 py-2 flex items-center justify-between"
      style={{ backgroundColor: bgColor }}
    >
      <div className="flex items-center gap-2 flex-1">
        {logoUrl && (
          <div className="w-3 h-3 rounded-full flex items-center justify-center shrink-0 overflow-hidden">
            <img
              src={logoUrl}
              alt={`${brandName} logo`}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <div className="leading-tight">
          <h1 className="text-white text-sm font-semibold m-0">
            {brandName}
          </h1>
          <p className="text-gray-400 text-xs m-0">{subtitle}</p>
        </div>
      </div>

      <div className="text-white text-xs font-normal whitespace-nowrap ml-2">{time}</div>
    </div>
  );
}
